<template>
  <transition
    name="fade"
  >
    <b-row
      v-show="componentReady"
      :class="formHeaderClasses"
    >
      <b-col
        cols="12"
        md="7"
        class="form-header-info"
      >
        <img
          v-if="formHeaderIcon"
          :src="iconFile"
          class="header-icon"
        >
        {{ formName }}
        <span
          v-if="!failedScreening && !formSubmitted"
          class="current-question"
        >
          <span v-if="!singleStep">
            (Step {{ currentPage }} of {{ numberOfPages }})
          </span>
          <span v-else>
            (Step {{ currentPage }} of 1)
          </span>
        </span>
        <span
          v-else-if="!failedScreening && formSubmitted"
          class="current-question"
        >
          Complete
        </span>
        <span
          v-else
          class="current-question"
        >
          STOP
        </span>
      </b-col>

      <b-col
        cols="12"
        md="5"
        class="form-header-user"
      >
        {{ selectedUser.itemName }}
      </b-col>
    </b-row>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { routes } from '../router/routes'

export default {
  name: 'FormHeader',
  data () {
    return {
      myRoute: {}
    }
  },
  computed: {
    ...mapGetters([
      'applicationReady',
      'selectedUser',
      'pageAlertInformation'
    ]),
    ...mapGetters({
      viewingQuestionnaire: 'forms/viewingQuestionnaire',
      currentQuestionnaire: 'forms/currentQuestionnaire',
      selectedQuestionnaireId: 'forms/selectedQuestionnaireId',
      currentPage: 'forms/currentPage',
      numberOfPages: 'forms/numberOfPages',
      formSubmitted: 'forms/formSubmitted',
      failedScreening: 'forms/failedScreening',
      singleStep: 'forms/singleStep'
    }),
    componentReady () {
      if (this.loggedIn) {
        return this.currentQuestionnaire !== undefined
      }
      return false
    },
    formHeaderClasses () {
      const classes = []
      classes.push('form-header')
      if (this.pageAlertInformation.message.length === 0) {
        classes.push('form-header-margin-bottom')
      }
      return classes
    },
    formName () {
      if (this.componentReady) {
        return this.currentQuestionnaire.name
      }
      return ''
    },
    formHeaderIcon () {
      return (this.componentReady && this.currentQuestionnaire.headerIcon !== undefined) ? this.currentQuestionnaire.headerIcon : false
    },
    currentQuestionnaireHeaderIcon () {
      return this.currentQuestionnaire.headerIcon
    },
    iconFile () {
      var images = require.context('../assets/', false, /\.png$/)
      return images('./' + this.currentQuestionnaire.headerIcon)
    }
  },
  watch: {
    currentQuestionnaire: {
      handler: function (newQuestionnaire, oldQuestionnaire) {
        if (newQuestionnaire !== undefined) {
          this.myRoute = routes.find(route => route.name === this.$router.currentRoute.name)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      logout: 'authentication/logout'
    })
  }
}
</script>

<style scoped lang="scss">
.form-header {
  background-color: #d6d7d8;
  font-size: 1.4rem;
  line-height: 3.2rem;
  padding: .5rem;
}

.form-header-info {
  text-align: center;
}

.form-header-user {
  text-align: center;
}

.form-header-margin-bottom {
  margin-bottom: 3rem;
}

.header-icon {
  max-width: 30px;
}

.current-question {
  color: #636466;
  font-size: 1rem;
  line-height: 3.2rem;
}

@media (min-width: 768px) {
  .form-header {
    padding: .5rem 3rem;
  }

  .form-header-info {
    text-align: left;
  }

  .form-header-user {
    text-align: right;
  }
}
</style>
